// El campo persistido (Alquiler.estado) solo distingue "activo"/"devuelto".
// "Vencido" es un sub-estado derivado de "activo" cuando ya pasó la fecha de
// devolución esperada — el mismo criterio que usa el proyecto para marcar
// una venta rápida como "Vencida" sin tocar su estado real en BD.
export const useEstadoAlquiler = () => {
  const calcularEstadoAlquiler = ({ estado, fechaHoraDevolucionEsperada }) => {
    if (estado === "devuelto") {
      return { text: "Devuelto", className: "bg-soccess color-white" };
    }

    const estaVencido =
      estado === "activo" &&
      !!fechaHoraDevolucionEsperada &&
      new Date(fechaHoraDevolucionEsperada).getTime() <= Date.now();

    if (estaVencido) {
      return { text: "Vencido", className: "bg-red color-white" };
    }

    return { text: "Activo", className: "bg-naranja color-white" };
  };

  return { calcularEstadoAlquiler };
};
